import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import RelatedArticles from "../../Components/RelatedArticles";

const DentalImmediateImplant = () => {
  const { t, i18n } = useTranslation();

  const lang = i18n.language;

  return (
    <div className="container py-5 mt-5" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/dental-immediate-implant"
        />

        <title>{t("dentalImmediateImplant.seo.title")}</title>
        <meta
          name="description"
          content={t("dentalImmediateImplant.seo.description")}
        />
        <meta
          name="keywords"
          content={t("dentalImmediateImplant.seo.keywords")}
        />
        <meta
          property="og:title"
          content={t("dentalImmediateImplant.seo.ogTitle")}
        />
        <meta
          property="og:description"
          content={t("dentalImmediateImplant.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Dental+Immediate+Implant"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={lang === "ar" ? "ar_AR" : "en_US"}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: t("dentalImmediateImplant.page.faq", {
              returnObjects: true,
            }).map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          })}
        </script>
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {t("dentalImmediateImplant.page.title")}
      </h1>
      <h5 className="text-center mb-3">
        {t("dentalImmediateImplant.page.subtitle")}
      </h5>
      <p className="text-center text-muted mb-2">
        {t("dentalImmediateImplant.page.author")}
      </p>

      {Object.values(
        t("dentalImmediateImplant.page.sections", { returnObjects: true })
      ).map((section, idx) => (
        <section key={idx} className="mt-4">
          <h2>{section.title}</h2>
          {section.text && <p>{section.text}</p>}
          {section.list && (
            <ul>
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      {t("dentalImmediateImplant.page.sections.references", {
        returnObjects: true,
      }) && (
        <section className="mt-5">
          <h2>{t("dentalImmediateImplant.page.sections.references.title")}</h2>
          <ol className="text-start" dir="ltr">
            {t("dentalImmediateImplant.page.sections.references.list", {
              returnObjects: true,
            }).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ol>
        </section>
      )}

      <RelatedArticles />
    </div>
  );
};

export default DentalImmediateImplant;
